<mat-form-field class="dynamicForm_alignment" [formGroup]="group">
  <mat-label><span>{{field.labelName}}</span>@if (isRequired) {
    <span>*</span>
  }</mat-label>
  <input matInput [min]="minDate" [max]="currentDate" [formControlName]="field.labelCode" [placeholder]="placeholderValue" autocomplete="off"
    [matDatepicker]="picker1">
    <mat-datepicker #picker1 (closed)="onClosed()"> </mat-datepicker>
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    @if (group.get(field.labelCode).hasError('matDatepickerMax')) {
      <mat-error>{{ValidationMessages.dateValidation}}</mat-error>
    }
    @if (group.get(field.labelCode).hasError('matDatepickerMin')) {
      <mat-error>{{field.labelCode === 'DOB' ? ValidationMessages.minDobDateValidation : ValidationMessages.dateValidation}}</mat-error>
    }
    @if (group.get(field.labelCode).hasError('matDatepickerParse')) {
      <mat-error>{{ValidationMessages.invalidDateFormat}}</mat-error>
    }
    @for (validation of field.validations; track validation) {
      <ng-container ngProjectAs="mat-error">
        @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase()) && !(group.get(field.labelCode).hasError(required))) {
          <mat-error>{{validation.message}}</mat-error>
        }
        @if (group.get(field.labelCode).hasError(required)) {
          <mat-error>{{field.labelName}} is mandatory</mat-error>
        }
      </ng-container>
    }
  </mat-form-field>